<div class="row pt-4 mb-5">
    <div class="col-md-5">
        <div class="card p-3 mb-4">
            <form role="form" [formGroup]="formCadastroCargos"
                (ngSubmit)="envioCargo()">
                <h5 class="my-2" *ngIf="!editandoCargo">Cadastro de cargo / pauta</h5>
                <h5 class="my-2" *ngIf="editandoCargo">Edição de cargo</h5>
                <hr>
                <div class="form-group">
                    <strong for="exampleInputEmail1">Título *</strong>
                    <input type="text" class="form-control" formControlName="nome" placeholder="Digite o título do cargo / pauta">
                    <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                    *ngIf="!formCadastroCargos.get('nome').valid && ( formCadastroCargos.get('nome').touched || isSubmit )">
                        <small>Campo título é obrigatório!</small>
                    </span>
                </div>
                <div class="form-group">
                    <strong for="exampleInputEmail1">Informações</strong>
                    <input type="text" class="form-control" formControlName="informacao" placeholder="Digite as informações para o cargo / pauta">
                </div>
                <div class="form-group">
                    <strong for="exampleInputEmail1">Label Cargo *</strong>
                    <input type="text" class="form-control" formControlName="labelCargo" placeholder="Digite o label para o cargo / pauta">
                    <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                    *ngIf="!formCadastroCargos.get('labelCargo').valid && ( formCadastroCargos.get('labelCargo').touched || isSubmit )">
                        <small>Campo Label Cargo é obrigatório!</small>
                    </span>
                </div>
                <div class="form-group" *ngIf="eleicao?.temPlanos">
                    <strong for="plano">Plano(s)</strong>
                    <div class="tags-container" (click)="removerTag(0)">
                      <div *ngFor="let tag of tags; let i = index" class="badge badge-info">
                        {{ tag }}
                        <!-- Passar o evento de clique e prevenir que o clique no 'X' seja propagado -->
                        <i class="fas fa-times" (click)="removerTag(i)"></i>
                      </div>
                    </div>
                    <div class="tag-input">
                      <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Digite o plano e pressione Enter"
                        [(ngModel)]="planoTagInput"
                        (keydown.enter)="adicionarTag($event)"
                        [ngModelOptions]="{standalone: true}" />
                    </div>
                  </div>
                  <div class="form-group" *ngIf="eleicao?.temPlanos">
                    <strong for="exampleInputEmail1">Agrupador</strong>
                    <input type="text" class="form-control" formControlName="agrupador" placeholder="Digite o agrupador para o cargo / pauta">
                </div>
                
                <div class="form-group">
                    <strong for="exampleInputPassword1">Qtd de vagas para o cargo / Qtd. Resp para a pauta*</strong>
                    <input type="number" min="1" class="form-control" formControlName="quantidadeEleitos">
                    <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                    *ngIf="!formCadastroCargos.get('quantidadeEleitos').valid && ( formCadastroCargos.get('quantidadeEleitos').touched || isSubmit )">
                        <small>Quantidade deve ser maior que zero!</small>
                    </span>
                </div>
                <button *ngIf="!editandoCargo" [disabled]="btOff" type="submit" class="btn btn-success btn-custom">Salvar</button>
                <button *ngIf="editandoCargo" [disabled]="btOff" type="submit" class="btn btn-success btn-custom">Salvar edição</button>
                <button *ngIf="editandoCargo" (click)="cancelarEdicao()" type="button" class="btn btn-light btn-custom mr-2">Cancelar edição</button>
            </form>
        </div>
    </div>
    <div class="col-md-7">
        <div class="card p-3">
            <div class="d-flex flex-row align-items-center">
                <h5 class="mb-0 mr-auto">Cargos / Pautas </h5> 
                <div class="justify-items-end btn-toolbar">
                    <button class="btn mr-2 btn-light ml-auto" (click)="baixarTemplate()" pTooltip="Baixar modelo de importação">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button class="btn btn-success ml-auto" data-toggle="modal" data-target="#meumodal" pTooltip="Importar candidatos / pautas">
                        <i class="fas fa-file-csv"></i>
                    </button>
                </div>
            </div>
            <hr>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="width: 51%;">Título</th>
                        <th class="text-center">Qtd. vagas / Qtd. Resp.válidas</th>
                        <th class="text-center" colspan="2">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of listaCargos">
                        <td>{{c?.nome}}</td>
                        <td class="text-center">{{c?.quantidadeEleitos}}</td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="editar" (click)="editarCargo(c)">
                                <i class="fas fa-edit fa-sm"></i>
                            </button>
                        </td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="excluir" (click)="excluirCargo(c.id)" [disabled]="btOff">
                                <i class="fas fa-trash fa-xs"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
 <!-- The Modal -->
 <div class="modal fade" id="meumodal" #content>
    <cadastro-massa-cargo></cadastro-massa-cargo>
 </div>

 
